module.exports = __webpack_public_path__ + "img/yellowLily.922959ca.jpg";